import { $, $$ } from '@utils';
import removeAccentMarkAndUppercase from '@utils/RemoveAccentMarkAndUppercase';

function init() {
  if (!$('[data-au-comparative-details]')) return;

  addEventListeners();
}

function addEventListeners() {
  document.addEventListener('click', handleToggleClick);

  $$('[data-au-comparative-toggle]').forEach((el) => {
    el.addEventListener('click', dataLayerComparativeDetails);
  });

  $$('[data-au-comparative-item-cta]').forEach((el) => {
    el.addEventListener('click', dataLayerComparativeCta);
  });
}

function dataLayerComparativeDetails(e) {
  const clickText = e.target.querySelector('[data-au-toggle-label]').innerText;
  const action = e.target.getAttribute('aria-expanded') === 'false' ? 'expandir' : 'contraer',
    item_id = `${removeAccentMarkAndUppercase(clickText)}_${removeAccentMarkAndUppercase(action)}`;

  window.dataLayer.push({
    event: 'navigation',
    content_type: 'clickBoton',
    item_id,
  });
}

function dataLayerComparativeCta(e) {
  const clickText = e.target.querySelector(':not([data-au-icon])').innerText;
  const titleText =
    e.target.closest('[data-au-comparative-item]')?.querySelector('[data-au-comparative-item-title]')?.innerText || '';
  const item_id = `${removeAccentMarkAndUppercase(titleText)}_${removeAccentMarkAndUppercase(clickText)}`;

  window.dataLayer.push({
    event: 'navigation',
    content_type: 'clickBoton',
    item_id,
  });
}

function applyToggle(t, isOpen) {
  const details = t.closest('[data-au-comparative-details]');
  if (!details) return;

  const content = details.querySelector('[data-au-comparative-content]');
  if (!content) return;

  content.classList.toggle('au-closed', isOpen);
  if (isOpen) {
    content.setAttribute('aria-hidden', 'true');
  } else {
    content.removeAttribute('aria-hidden');
  }
  t.setAttribute('aria-expanded', String(!isOpen));

  const labelSpan = t.querySelector('[data-au-toggle-label]');
  if (labelSpan) {
    labelSpan.textContent = isOpen ? t.getAttribute('data-au-open-label') : t.getAttribute('data-au-close-label');
  }

  const iconEl = t.querySelector('[data-au-toggle-icon]');
  if (iconEl) {
    iconEl.textContent = isOpen ? 'expand_more' : 'expand_less';
  }
}

function handleToggleClick(e) {
  const toggle = e.target.closest('[data-au-comparative-toggle]');
  if (!toggle) return;

  const clickedDetails = toggle.closest('[data-au-comparative-details]');
  if (!clickedDetails) return;

  const isOpen = !clickedDetails.querySelector('[data-au-comparative-content]').classList.contains('au-closed');

  // Find all sibling cards in the same slider (or just this card if standalone)
  const slider = toggle.closest('[data-au-comparative-slider]');
  const toggles = slider ? slider.querySelectorAll('[data-au-comparative-toggle]') : [toggle];

  toggles.forEach((t) => {
    applyToggle(t, isOpen);
  });

  // Also toggle all cards in the other sliders of the same module (silently, no label change)
  const module = toggle.closest('[data-au-comparative]');
  if (module && slider) {
    module
      .querySelectorAll('[data-au-comparative-slider]:not(.swiper-initialized), [data-au-comparative-slider]')
      .forEach((otherSlider) => {
        if (otherSlider === slider) return;
        otherSlider.querySelectorAll('[data-au-comparative-toggle]').forEach((t) => {
          applyToggle(t, isOpen);
        });
      });
  }

  // Sync legend visibility in parent module
  if (module) {
    const groupId = slider?.dataset.auSegmentedControlTarget;
    const legend = groupId
      ? module.querySelector(`[data-au-comparative-legend="${groupId}"]`)
      : module.querySelector('[data-au-comparative-legend]');
    if (legend) {
      legend.classList.toggle('au-closed', isOpen);
      legend.setAttribute('aria-hidden', isOpen ? 'true' : 'false');
    }
  }
}

export default { init };
